import { useEffect } from 'react';

/** LinkedIn Insight community template in GTM-5T745KG (tags 22–25). */
const LINKEDIN_INSIGHT_GTM_TEMPLATE = 'cvt_134790840_21';

/**
 * Helper to load external script
 */
function loadScript(
  src: string,
  options?: { async?: boolean; defer?: boolean },
) {
  const script = document.createElement('script');
  script.src = src;
  script.async = options?.async ?? true;
  if (options?.defer) script.defer = true;
  document.head.appendChild(script);
  return script;
}

function ScriptsHeader() {
  useEffect(() => {
    // Google Tag Manager
    // @ts-expect-error - GTM global
    window.dataLayer = window.dataLayer || [];
    // Prepend the policy so GTM applies it before any already-queued events.
    // The GTM runtime strips leading __ from template IDs.
    // @ts-expect-error - GTM global
    window.dataLayer.unshift({
      'gtm.blocklist': [LINKEDIN_INSIGHT_GTM_TEMPLATE],
    });
    // @ts-expect-error - GTM global
    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });
    loadScript('https://www.googletagmanager.com/gtm.js?id=GTM-5T745KG');

    // Facebook Pixel (lazy load)
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(() => initFacebookPixel());
    } else {
      setTimeout(() => initFacebookPixel(), 200);
    }

    function initFacebookPixel() {
      // @ts-expect-error - Facebook Pixel global
      if (window.fbq) return;
      // @ts-expect-error - Facebook Pixel global
      const n = (window.fbq = function () {
        // @ts-expect-error - Facebook Pixel global
        n.callMethod
          ? // @ts-expect-error - Facebook Pixel global
            n.callMethod.apply(n, arguments)
          : // @ts-expect-error - Facebook Pixel global
            n.queue.push(arguments);
      });
      // @ts-expect-error - Facebook Pixel global
      if (!window._fbq) window._fbq = n;
      // @ts-expect-error - Facebook Pixel global
      n.push = n;
      // @ts-expect-error - Facebook Pixel global
      n.loaded = true;
      // @ts-expect-error - Facebook Pixel global
      n.version = '2.0';
      // @ts-expect-error - Facebook Pixel global
      n.queue = [];

      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      s.parentNode?.insertBefore(t, s);

      // @ts-expect-error - Facebook Pixel global
      window.fbq('init', '117101947893768');
      // @ts-expect-error - Facebook Pixel global
      window.fbq('track', 'PageView');
    }

    // Google Ads gtag
    loadScript('https://www.googletagmanager.com/gtag/js?id=AW-11250474634');

    // @ts-expect-error - gtag global
    window.dataLayer = window.dataLayer || [];
    function gtag(...args: unknown[]) {
      // @ts-expect-error - gtag global
      window.dataLayer.push(args);
    }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', 'AW-11250474634');
    gtag('event', 'conversion', {
      send_to: 'AW-11250474634/tH4hCISv97cYEIq90vQp',
    });
  }, []);

  return (
    <noscript>
      <img
        height="1"
        width="1"
        style={{ display: 'none' }}
        src="https://www.facebook.com/tr?id=117101947893768&ev=PageView&noscript=1"
        alt=""
      />
    </noscript>
  );
}

export default ScriptsHeader;
